import React from 'react';
import PropTypes from 'prop-types';
import connect from './connect';
import * as Api from 'api';
import { Row, Col, Alert, SplitButton, MenuItem } from 'react-bootstrap';
import ReactTable from 'react-table';
import { Checkbox } from 'components';


class Toolbar extends React.Component {
  static PropTypes = {
    columns: PropTypes.array,
    onDelete: PropTypes.func,
    onSelectAll: PropTypes.func,
    selected_columns: PropTypes.array,
    onSelectColumn: PropTypes.func.isRequired,
  }
  render() {
    const { columns, selected_columns, onSelectAll, onDelete } = this.props;
    return (
      <div style={{ overflow: 'visible' }} className="inner-toolbar clearfix">
        <ul>
          <li style={{ padding: 0 }}>
            <SplitButton id='page-table-dropdown' bsStyle={'dark'} bsSize='lg' title={`Columns (${selected_columns.length})`}>
              {columns.filter(item => item.accessor).map((item, idx) => (
                <MenuItem key={idx} onSelect={e => {
                  this.props.onSelectColumn(item.accessor)
                }} className='' key={item.accessor}>
                  <span className='pull-left'><Checkbox checked={selected_columns.find(column => item.accessor == column) ? true : false} /></span> {item.header}
                </MenuItem>
              ))}
            </SplitButton>
          </li>
          {onSelectAll ? <li>
            <a href="#" onClick={e => {
              e.preventDefault();
              onSelectAll();
            }} id="mgSelectAll"><i className="fa fa-check-square"></i> <span>Select All</span></a>
          </li> : null}
          {/* <li>
          <a href="#"><i className="fa fa-pencil"></i> Edit</a>
          </li> */}
          {onDelete ? <li>
            <a onClick={e => {
              e.preventDefault();
              onDelete();
            }} href="#"><i className="fa fa-trash-o"></i> Delete</a>
          </li> : null}
          <li className="right">

            {/* <ul className="nav nav-pills nav-pills-primary">
              <li>
              <label>Filter:</label>
              </li>
              <li className="active">
              <a data-option-value="*" href="#all">All</a>
              </li>
              <li>
              <a href="#document">Documents</a>
              </li>
              <li>
              <a href="#image">Images</a>
              </li>
              <li>
              <a href="#video">Videos</a>
              </li>
            </ul> */}
          </li>
        </ul>
      </div>
    );
  }
}

class Table extends React.Component {
  static PropTypes = {
    size: PropTypes.number,
    sort: PropTypes.object,
    total: PropTypes.number,
    offset: PropTypes.number,
    columns: PropTypes.array,
    results: PropTypes.array,
    filters: PropTypes.object,
    loading: PropTypes.bool,
    message: PropTypes.string,
    onFetch: PropTypes.func,
    onDelete: PropTypes.func,
    onSelectAll: PropTypes.func,
    downloading: PropTypes.bool,
    showToolbar: PropTypes.bool,
    onSelectColumn: PropTypes.func,
    selected_columns: PropTypes.array,
  }
  constructor(props) {
    super(props);

    this.state = {
      pageSize: 10,
      pageIndex: 0,
      selected_columns: this.props.selected_columns
    };

    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
    this.fetch = this.fetch.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.resizePage = this.resizePage.bind(this);
    this.handleSelectColumn = this.handleSelectColumn.bind(this);
  }
  fetch(props) {
    const {
      size,
      offset,
      filters,
    } = this.props;
    if(!this.props.onFetch) {
      return console.warn(`No fetch provided!`);
    }
    this.props.onFetch({
      size,
      offset,
      filters,
      ...(props || {})
    });
  }
  next() {
    const { downloading } = this.props;
    if(!downloading) {
      const offset = this.props.offset + 1;
      this.fetch({ offset });
    }
  }
  prev() {
    const { downloading } = this.props;
    if(!downloading) {
      const offset = this.props.offset > 0? this.props.offset - 1 : 0;
      this.fetch({ offset });
    }
  }
  pageChange(pageIndex){
    this.fetch({ offset: pageIndex });
  }
  resizePage(pageSize) {
    this.setState({ pageSize });
    this.fetch({ size: pageSize });
  }
  handleSelectColumn(column) {
    const { selected_columns } = this.state;
    const s_column = selected_columns.find(s => s == column);

    this.setState({
      selected_columns: s_column ? selected_columns.filter(s_column => s_column != column) : [column, ...selected_columns]
    });
  }
  componentDidMount() {
    this.fetch();
  }
  render() {
    let { selected_columns } = this.state;
    let {
      columns,
      message,
      filters,
      results,
      size,
      offset,
      sort,
      total,
      downloading,
      loading,
      showToolbar
    } = this.props;

    columns = columns || [];
    selected_columns = selected_columns || [];

    return (
      <div>
        {showToolbar ? <Toolbar
          columns={columns}
          onSelectColumn={this.handleSelectColumn}
          onSelectAll={this.props.onSelectAll}
          onDelete={this.props.onDelete}
          selected_columns={selected_columns}
        /> : null}
        <div style={{ marginLeft: '-40px', marginRight: '-40px' }}>
          <ReactTable
            style={{ position: 'absolute', right: 0, left: 0, bottom: 0, top: showToolbar ? 50: 0, overflowY: 'auto' }}
            loading={loading}
            data={results}
            columns={[
              ...columns.filter(column => !column.accessor),
              ...columns.filter(column => selected_columns.find(item => item == column.accessor))
            ]}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            page={offset}
            pages={Math.ceil(total/this.state.pageSize)}
            manual
            pageSize={this.state.pageSize}
            defaultPageSize={10}
            onPageChange={this.pageChange}
            onPageSizeChange={this.resizePage}
            onSortingChange={() => {}}
            onResize={() => {}}
            onFilteringChange={() => ({

            })}
            getTheadProps={() => ({

            })}
            getPaginationProps={() => ({

            })}
            getTrGroupProps={() => ({
              // style : {
              //   marginBottom: 5,
              //   marginTop: 5,
              //   backgroundColor: '#eeeeee',
              //   borderBottomColor: '#ABB4BE',
              //   borderLeftColor: '#34AAB0',
              //   borderLeftWidth: 5,
              // }
            })}
          />
        </div>
      </div>
    )
  }
}
export default Table;



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/table.js